import { CustomBox } from "components";
import { TotalUserIcon } from "pages/internal-dashboard/icons";
import { getGrowthTrends } from "../../helpers";

export function TotalUsers({ data, isLoading }: any) {
  const { today, thisWeek, thisMonth, thisYear, total } = data || {};

  const growthTrends = getGrowthTrends(data);

  return (
    <CustomBox
      color="#006AB3"
      loading={isLoading}
      title="Total users"
      userCount={total || 0}
      boxData={{
        label: "User Base",
        description:
          "The overall number of users who have registered on the platform.",
        todayCount: today || 0,
        weekCount: thisWeek || 0,
        monthCount: thisMonth || 0,
        yearCount: thisYear || 0,
        icon: TotalUserIcon,
      }}
      percentages={growthTrends}
    />
  );
}
